import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TermsService {
    private termsAccepted = '0';

    constructor() {
        // Check local storage on service initialization
        const storedTermsAccepted = localStorage.getItem('terms');
        if (storedTermsAccepted) {
            this.termsAccepted = storedTermsAccepted;
        }
    }

    setTermsAccepted(accepted: boolean): void {
        this.termsAccepted = accepted ? '1' : '0';
        localStorage.setItem('terms', this.termsAccepted);
    }

    isTermsAccepted(): boolean {
        if (window.location.hostname === 'scavo.venturesonsite.com') {
            return this.termsAccepted === '1';
        } else {
            return true;
        }
    }
}
